import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { ShoppingBag, Store, TrendingUp } from 'lucide-react';

export const ProfileRoleSelector = ({ role, setRole, setShowInfluencerWhatsApp }) => (
  <div>
    <Label className="mb-3 block">Tipo de Conta</Label>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <Button type="button" variant={role === 'user' ? 'default' : 'outline'}
        onClick={() => setRole('user')}
        className={`flex flex-col items-center gap-2 h-auto py-4 ${role === 'user' ? 'bg-amber-500 hover:bg-amber-600 text-white border-amber-500' : 'border-slate-300 text-slate-700'}`}
        data-testid="role-user">
        <ShoppingBag className="h-6 w-6" />
        <span className="text-xs font-medium text-center leading-tight">Consumidor<br/>Quero usar cupons</span>
      </Button>
      <Button type="button" variant={role === 'merchant' ? 'default' : 'outline'}
        onClick={() => setRole('merchant')}
        className={`flex flex-col items-center gap-2 h-auto py-4 ${role === 'merchant' ? 'bg-amber-500 hover:bg-amber-600 text-white border-amber-500' : 'border-slate-300 text-slate-700'}`}
        data-testid="role-merchant">
        <Store className="h-6 w-6" />
        <span className="text-xs font-medium text-center leading-tight">Lojista<br/>Quero criar cupons</span>
      </Button>
      <Button type="button" variant={role === 'influencer' ? 'default' : 'outline'}
        onClick={() => { setRole('influencer'); setShowInfluencerWhatsApp(true); }}
        className={`flex flex-col items-center gap-2 h-auto py-4 ${role === 'influencer' ? 'bg-indigo-600 hover:bg-indigo-700 text-white border-indigo-600' : 'border-slate-300 text-slate-700'}`}
        data-testid="role-influencer">
        <TrendingUp className="h-6 w-6" />
        <span className="text-xs font-medium text-center leading-tight">Influenciador<br/>Quero indicar lojistas</span>
      </Button>
    </div>
  </div>
);
